<template>
    <div class="flex min-h-screen bg-gray-50 print:bg-white">
        <Sidebar :user="user" />

        <main class="flex-1 ml-64 print:ml-0">
            <Header />
            <router-view />
        </main>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { auth } from "../../firebase/config.js";
import { onAuthStateChanged } from "firebase/auth";

import Sidebar from "../layout/Sidebar.vue";
import Header from "../layout/HeaderPrint.vue";

import { clearSelectedPatient } from "../../stores/selectedPatient.js";

const router = useRouter();
const route = useRoute();

const user = ref(auth.currentUser);

let unsubAuth = null;

onMounted(() => {
    unsubAuth = onAuthStateChanged(auth, (u) => {
        user.value = u || null;
        if (!u) router.replace({ name: "login" });
    });
});

onUnmounted(() => {
    if (unsubAuth) unsubAuth();
});

watch(
    () => route.name,
    (name) => {
        if (name !== "formular" && name !== "istoric") {
            clearSelectedPatient();
        }
    }
);
</script>
